import App from './App';
import CssBaseline from '@mui/material/CssBaseline';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';

import axios from 'axios';
import theme from './theme/theme';

// Make sure all calls use cookies
axios.defaults.withCredentials = true;

createRoot(
  document.querySelector('#root') as HTMLElement
).render(
  <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <App />
      </ThemeProvider>
  </StyledEngineProvider>
);
